export default __webpack_public_path__ + "static/media/DocumentUploadIcon.70ed71bc.svg";